import { debauchery } from './debauchery';
import { league } from './league';
import { modern } from './modern';
import { patriotic } from './patriotic';
// import { storm_3d } from './storm_3d';
import { traditional } from './traditional';

export const rugby = {
  traditional,
  modern,
  debauchery,
  patriotic,
  league,
  // storm_3d,
};
